import type { TCountryCode } from "countries-list";

export const COUNTRY_ADDRESS_CONFIG: Partial<
    Record<TCountryCode, { mergeLeadingHouseNumber: boolean }>
> = {
    JP: { mergeLeadingHouseNumber: false },
};

export const REVERSE_NAME_ORDER_COUNTRY_CODES: TCountryCode[] = ["KR", "JP"];
export const SHIPPING_PREFIX = "deliveryAddress";
export const BILLING_PREFIX = "billingAddress";
export const CountryWithPostalCodeAsAddressLookup = ["JP"];
export const GOOGLE_PROJECT_NAME = process.env.NEXT_PUBLIC_GOOGLE_PROJECT_NAME;
